import { Caring } from "./Caring";
import {
  Categories,
  Ledger,
  Employee,
  Wood,
  WoodType,
  Products,
  UnitType,
} from "./CreateProductType";

export interface MasterState {
  categories: Categories[];
  employees: Employee[];
  woods: Wood[];
  woodtypes: WoodType[];
  ledgers: Ledger[];
  products: Products[];
  unittypes: UnitType[];
  usedBomProductIds: number[];
  loading: boolean;
  loaded: boolean;
}

const initialState: MasterState = {
  categories: [],
  employees: [],
  woods: [],
  woodtypes: [],
  ledgers: [],
  products: [],
  unittypes: [],
  usedBomProductIds: [],
  loading: false,
  loaded: false,
};

export { initialState };
